import { FEATURE_ENUM } from '@partoohub/api-client';

import { ORG_ADMIN } from 'app/common/data/roles';
import { useHasFeature } from 'app/common/hooks/accessesAndPermissions/pages/useHasFeature';
import env from 'app/common/services/getEnvironment';
import { useMe } from 'app/pages/app/AppDataProvider/hooks/useMe';

export const useHasChatbotPage = (): boolean => {
    const me = useMe();

    const hasMessagesFeature = useHasFeature(FEATURE_ENUM.MESSAGES);
    const hasChatbot = useHasFeature(FEATURE_ENUM.JIM);

    const hasChatbotFeature = env.isSandbox() || hasChatbot;

    const hasCorrectRole = me.role === ORG_ADMIN;

    return hasMessagesFeature && hasChatbotFeature && hasCorrectRole;
};
